import React from "react";

const RegistrationComplete = () => {
  return <div>rc</div>;
};

export default RegistrationComplete;
